export default function parseExpiryFromAccessToken(token: string): number | null {
  const header = token.split('.')[0];

  // istanbul ignore if
  if (!header) {
    return null;
  }

  try {
    const parsedHeader = JSON.parse(window.atob(header));
    // exp is a unix timestamp in seconds. We need to convert it to the delta
    // between it and the current time
    const nowInSeconds = Date.now() / 1000;
    return Math.round(parsedHeader.exp - nowInSeconds);
  } catch (_) /* istanbul ignore next */ {
    return null;
  }
}
